module.exports = __webpack_public_path__ + "img/12.70f96a1f.jpg";